import { render, staticRenderFns } from "./NewChartComponent.vue?vue&type=template&id=97f89b2c&"
import script from "./NewChartComponent.vue?vue&type=script&lang=js&"
export * from "./NewChartComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewChartComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports